import * as React from 'react';
import { Row } from 'react-bootstrap';
import type { CustomRouteComponentProps } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import { Button } from '@acceligentllc/storybook';

import type { BreadcrumbItem } from 'af-components/Breadcrumbs';
import Breadcrumbs from 'af-components/Breadcrumbs';

interface OwnProps {
	backToListLabel?: string;
	backToListUrl?: string;
	breadcrumbs: BreadcrumbItem[];
	editLabel?: string;
	editUrl?: string;
	isSmall?: boolean;
}

type Props = React.PropsWithChildren<OwnProps> & CustomRouteComponentProps<void>;

const ResourcePreview: React.FC<Props> = React.memo((props: Props) => {
	const {
		breadcrumbs,
		backToListUrl,
		editUrl,
		backToListLabel,
		children,
		editLabel = 'Edit',
		isSmall = false,
		history,
	} = props;

	let segmentClassName = 'form-segment';
	segmentClassName = isSmall ? `${segmentClassName} form-segment--mini` : segmentClassName;

	const backToListAction = React.useCallback(() => {
		if (!backToListUrl) {
			return;
		}
		history.push(backToListUrl);
	}, [backToListUrl, history]);

	const editRedirectAction = React.useCallback(() => {
		if (!editUrl) {
			return;
		}
		history.push(editUrl);
	}, [editUrl, history]);

	return (
		<div className={segmentClassName}>
			<Breadcrumbs items={breadcrumbs} />
			<div className="form-box">
				{children}
				<Row className="row--submit">
					{
						backToListLabel && backToListUrl &&
						<Button
							label={backToListLabel}
							onClick={backToListAction}
							style="secondary"
							type="button"
						/>
					}
					{
						editUrl &&
						<Button
							label={editLabel}
							onClick={editRedirectAction}
							style="secondary"
							type="button"
						/>
					}
				</Row>
			</div>
		</div>
	);
});

export default withRouter(ResourcePreview);
